import styled from 'styled-components';

const SectionWrap = styled.div`
  margin-bottom: 32px;
`;

export default SectionWrap;
